import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "td__use-yn" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "td__ceo-phone" };
const _hoisted_6 = { class: "td__business-number" };
const _hoisted_7 = { class: "td__working-time" };
const _hoisted_8 = { class: "td__add-charge-apply-yn" };
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "td__virtual-bank-code" };
const _hoisted_11 = { class: "td__virtual-bank-account" };
const _hoisted_12 = { class: "td__baromoney" };
const _hoisted_13 = { class: "td__deposit-baromoney" };
const _hoisted_14 = { class: "td__withdrawable-amount" };
const _hoisted_15 = { class: "td__created-at" };
import { computed, toRefs, } from 'vue';
import { makeItemToComputed } from '@/utils/vueUtils';
import { routeName } from '@/constants/routeName';
import { hubStatusOptionList } from '@/constants/hubManagement';
import { useRouter } from 'vue-router';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const { item, } = toRefs(props);
        const router = useRouter();
        const getterSearchField = computed(() => vuexStore.getters['hubManagement/hubList/getterSearchField']);
        const getterSearchValue = computed(() => vuexStore.getters['hubManagement/hubList/getterSearchValue']);
        const getterHubStatusType = computed(() => vuexStore.getters['hubManagement/hubList/getterHubStatusType']);
        const getterPageSizeType = computed(() => vuexStore.getters['hubManagement/hubList/getterPageSizeType']);
        const hubStatusImgPath = computed(() => {
            const [hubStatus,] = hubStatusOptionList
                .filter((option) => option.value === item.value.useYn);
            return `/svg/use-yn-${hubStatus.imgIcon}.svg`;
        });
        const validatedHubName = makeItemToComputed(item, 'validatedHubName');
        const formattedWorkingTime = makeItemToComputed(item, 'formattedWorkingTime');
        const validatedBusinessNumber = makeItemToComputed(item, 'validatedBusinessNumber');
        const validatedCeoName = makeItemToComputed(item, 'validatedCeoName');
        const formattedCeoPhone = makeItemToComputed(item, 'formattedCeoPhone');
        const formattedShortenAddress = makeItemToComputed(item, 'formattedShortenAddress');
        const formattedAddChargeApplyYn = makeItemToComputed(item, 'formattedAddChargeApplyYn');
        const validatedVirtualBankName = makeItemToComputed(item, 'validatedVirtualBankName');
        const validatedVirtualBankAccount = makeItemToComputed(item, 'validatedVirtualBankAccount');
        // const validatedDeliveryDetail = makeItemToComputed(item, 'validatedDeliveryDetail');
        // const validatedDeliveryFeeMonthlyDay = makeItemToComputed(item, 'validatedDeliveryFeeMonthlyDay');
        const formattedDepositBaromoney = makeItemToComputed(item, 'formattedDepositBaromoney');
        const formattedBaromoney = makeItemToComputed(item, 'formattedBaromoney');
        const formattedWithdrawableAmount = makeItemToComputed(item, 'formattedWithdrawableAmount');
        const formattedCreatedAt = makeItemToComputed(item, 'formattedCreatedAt');
        /**
         * 허브명 클릭 핸들러
         */
        const handleClickHubName = (hubId) => {
            router.push({
                name: routeName.HUB_MANAGEMENT_DETAIL,
                params: {
                    hubId,
                },
                query: {
                    searchField: getterSearchField.value,
                    searchValue: getterSearchValue.value,
                    hubStatusType: getterHubStatusType.value,
                    pageSizeType: getterPageSizeType.value,
                },
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createCommentVNode(" 상태 "),
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("img", { src: hubStatusImgPath.value }, null, 8 /* PROPS */, _hoisted_2)
                ]),
                _createCommentVNode(" 허브명 "),
                _createElementVNode("td", {
                    class: "td__hub-name",
                    title: _unref(validatedHubName),
                    onClick: _cache[0] || (_cache[0] = ($event) => (handleClickHubName(_unref(item).code)))
                }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(validatedHubName)), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_3),
                _createCommentVNode(" 대표자명 "),
                _createElementVNode("td", {
                    class: "td__ceo-name",
                    title: _unref(validatedCeoName)
                }, _toDisplayString(_unref(validatedCeoName)), 9 /* TEXT, PROPS */, _hoisted_4),
                _createCommentVNode(" 대표자 휴대폰번호 "),
                _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(formattedCeoPhone)), 1 /* TEXT */),
                _createCommentVNode(" 사업자 등록번호 "),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(validatedBusinessNumber)), 1 /* TEXT */),
                _createCommentVNode(" 업무시간 "),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formattedWorkingTime)), 1 /* TEXT */),
                _createCommentVNode(" 할증대행료 "),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formattedAddChargeApplyYn)), 1 /* TEXT */),
                _createCommentVNode(" 주소 "),
                _createElementVNode("td", {
                    class: "td__address",
                    title: _unref(formattedShortenAddress)
                }, _toDisplayString(_unref(formattedShortenAddress)), 9 /* TEXT, PROPS */, _hoisted_9),
                _createCommentVNode(" 가상계좌은행 "),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(validatedVirtualBankName)), 1 /* TEXT */),
                _createCommentVNode(" 충전 가상계좌번호 "),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(validatedVirtualBankAccount)), 1 /* TEXT */),
                _createCommentVNode("바로머니 잔액"),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formattedBaromoney)), 1 /* TEXT */),
                _createCommentVNode("예치금"),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formattedDepositBaromoney)), 1 /* TEXT */),
                _createCommentVNode(" 출금가능금액 "),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formattedWithdrawableAmount)), 1 /* TEXT */),
                _createCommentVNode(" 허브 등록일 "),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formattedCreatedAt)), 1 /* TEXT */)
            ]));
        };
    }
});
